module.exports = __webpack_public_path__ + "static/img/9.e8e211d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/9.jpg
// module id = uwYJ
// module chunks = 0